<div id="header">
    <h1 *ngIf="no" class="mat-display-1" id="no">{{no}}</h1>
    <div [ngClass]="{ 'centered-section': centerText}">
        <h1 class="mat-display-2">{{title}}</h1>
        <p id="subheading">{{subtitle}}</p>
    </div>
</div>